import logo from './img/geo-lizard-white.png';
import './App.css';
import { SettingOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Layout, Menu } from 'antd';
import Mapbox from './mapbox';
import { useMapboxContext } from './mapbox/context/mapbox-context';

const { Header, Content, Footer } = Layout;

function App() {
  const { isOpenSettings, setMenuSettings } = useMapboxContext();

  const openSettings = () => {
    setMenuSettings(!isOpenSettings);
  }

  const items: MenuProps['items'] = ['settings'].map((key) => ({
    key,
    label: <SettingOutlined style={{ fontSize: '20px' }} />,
    onClick: openSettings
  }));

  return (

    <Layout style={{ display: "grid", gridTemplateRows: "auto 1fr auto", minHeight: "100vh" }}>
      <Header >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <img src={logo} width={150} alt="logo" />

          <Menu theme="dark" mode="horizontal" items={items} />
        </div>
      </Header>
      <Content style={{ padding: '0, 50px' }}>
        <Mapbox />
      </Content>
      <Footer style={{ textAlign: 'center', backgroundColor: "black", color: "white" }}>
        <a href="https://www.lagarsoft.com/" style={{ color: "white" }} target="_blank"> Powered By Lagarsoft</a>
      </Footer>
    </Layout>
  );
}

export default App;
